<era-device-swapped-current-action-bar-ui [allowUnavailable]="allowUnavailable$ | async"
                                          [allowSpare]="allowSpare$ | async"
                                          [device]="device$"></era-device-swapped-current-action-bar-ui>